module.exports = __webpack_public_path__ + "mali.svg?65d0a5e6265d7191e74bc9308e0129d7";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/countries/svg/mali.svg
// module id = 224
// module chunks = 10